import type { AssistantLink } from '@/types/support-assistant';

// Must stay in sync with api/src/modules/support-assistant/actions/assistant-links.util.ts
export const MAX_ASSISTANT_LINKS = 4;

const MEMBER_HREF = /^\/members\/[a-f0-9]{24}\/view$/;
const LEAD_HREF = /^\/leads\/[a-f0-9]{24}\/view$/;
const GHL_PATH = /^\/v2\/location\/[A-Za-z0-9]{1,64}\/contacts\/detail\/[A-Za-z0-9]{1,64}$/;

export function isAssistantLink(value: unknown): value is AssistantLink {
  if (!value || typeof value !== 'object') return false;
  const { type, href } = value as { type?: unknown; href?: unknown };
  if (typeof href !== 'string') return false;
  if (type === 'member') return MEMBER_HREF.test(href);
  if (type === 'lead') return LEAD_HREF.test(href);
  if (type === 'ghl_contact') {
    try {
      const u = new URL(href);
      return u.protocol === 'https:' && GHL_PATH.test(u.pathname) && u.search === '' && u.hash === '';
    } catch {
      return false;
    }
  }
  return false;
}

export function filterAssistantLinks(input: unknown): AssistantLink[] {
  if (!Array.isArray(input)) return [];
  const seen = new Set<string>();
  const out: AssistantLink[] = [];
  for (const item of input) {
    if (!isAssistantLink(item) || seen.has(item.href)) continue;
    seen.add(item.href);
    out.push({ type: item.type, href: item.href });
    if (out.length >= MAX_ASSISTANT_LINKS) break;
  }
  return out;
}
